var exports = {
  "tJ": "metadataContainer__732jeT",
  "c7": "metadataCell__AiHmVv",
  "Ev": "metadataReview__wrMW2J",
  "Um": "metadataStatus__lWJdNr",
  "oh": "metadataUtility__Lpjwy0",
  "MR": "metadataAssignees__0xbMoe",
  "zC": "emptyPlaceholder__ri2wQD",
  "Pb": "leftMetadata__OFjcrw",
  "i7": "leftMetadataText__CcnfDx",
  "yk": "leftMetadataSeparator__VvNUGq",
};

module.exports = exports;
